

import {useState, useEffect, memo, useMemo} from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "../../../../assets/images/logos/darwynn/DarwynnAvatar.svg"
import backgroundImage from "assets/images/bg-profile.jpeg";

import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import PasswordIcon from '@mui/icons-material/Password';
import LinkIcon from '@mui/icons-material/Link';
import * as React from 'react';
import Box from '@mui/material/Box';
import UserInfo from "../../userInformation/UserInfo";
import Typography from "@mui/material/Typography";
import PasswordSetting from "../../passwordSetting/PasswordSetting";
import {useDispatch, useSelector} from "react-redux";
import {getUserSetting} from "../../../../actions";
import MultiAddress from "../../multiAddress/Multiaddress";
import PaymentPage from "../../../system/payment";
import {useLocation, useNavigate} from "react-router-dom";
import LocalStorage from "../../../../utils/LocalStorage";
import axios from "axios";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import ConnectionPage from "../../connectionPage/ConnectionPage";
import ProductSearch from "../../../inventory/stockCheck/ProductSearch";
import BatchSearch from "../../../inventory/stockCheck/BatchSearch";
import KeepAlive from "keepalive-for-react";
import {useTranslation} from "react-i18next";



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            // style={{height:"75vh"}}
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function Header() {
    // const userInfo = useSelector(state => state?.auth?.userSetting);
    const [userInfo,setUserInfo] = useState({})
    const dispatch = useDispatch();
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [tabValue, setTabValue] = useState(0);
    const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    const tab = LocalStorage.getItem("selectedAccountTab");
    const nav= useNavigate()
    const {t} = useTranslation();
    const [avatarImg , setAvatarImg] = useState(null)
    const [isLoading,setIsLoading] = useState(false)
    const [cacheLoading,setCacheLoading] = useState(false)


    let tabs = [
        {value: 0, name:'userInfo', cache: true, component: UserInfo},
        {value: 1, name:'passwordSetting',cache: true, component: PasswordSetting}
    ];

    if (checkPermission(PERMISSION_DICT.BillingInvoiceConnect)) {
        tabs.push({ value: 2, name: 'connectionPage', cache: true, component: ConnectionPage });
    }

    if (!checkPermission(PERMISSION_DICT.QueryOwnerInfo)) {
        tabs.push(
            { value: 2, name: 'payment', cache: true, component: PaymentPage },
            { value: 3, name: 'address', cache: true, component: MultiAddress }
        );
    }

    const onGetUserInfoSuccess = (data) =>{
        setUserInfo(data.data?.userInfo)
        setIsLoading(false)
        // getAvatarUrl()
    }
    const getUserInfoFetch = ()=>{
        dispatch(getUserSetting(onGetUserInfoSuccess))
    }

    useEffect(() => {
        // if(!queryParams.get('tab')){
        //     nav(`/app/account?tab=0`)
        // }
        setIsLoading(true)
        getUserInfoFetch()
    }, [])

    useEffect(() => {
        if(!cacheLoading){
            nav(location.pathname)
        }
    }, [cacheLoading]);

    useEffect(()=>{

        if(tab!==null){
            setTabValue(Number(tab))
        }

    },[tab])


  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => {
      setCacheLoading(true)
      nav(location.pathname)
      LocalStorage.setItem("selectedAccountTab",newValue);
      setTabValue(newValue)
  };

    const page = useMemo(() => {
        return tabs.find(tab => tab.value === tabValue);
    }, [tabValue]);

    useEffect(()=>{
        nav(location.pathname)
        setCacheLoading(false)
        nav(location.pathname)
    },[page])


    useEffect(() => {
        return () => {
            LocalStorage.setItem("selectedAccountTab",0);
        };
    }, [dispatch]);


    useEffect( () => {
        if (!!userInfo){
            getAvatarUrl()
        }
    }, [userInfo]);

    useEffect(()=>{
        LocalStorage.setItem('accountTab', tabValue);
    },[tabValue])


    const [avatarUrl,setAvatarUrl] = useState(null)

    function isUrl(url) {
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        return urlRegex.test(url);
    }

    const getAvatarUrl = async () =>{
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            setAvatarUrl(burceMars)
        } else {
            if (!!userInfo?.logoImage && isUrl(userInfo?.logoImage)) {
                await axios.get(userInfo?.logoImage).then(res => {
                    if (res.status === 200) {
                        setAvatarUrl(userInfo?.logoImage)
                    } else {
                        setAvatarUrl(burceMars)
                    }
                }).catch(err => {
                    setAvatarUrl(burceMars)
                })
            }else {
                setAvatarUrl(burceMars)
            }
        }
    }

  return (
    <MDBox position="relative" mb={5} sx={{marginTop:'-21px'}}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -25,
          mx: 3,
          py: 2,
          px: 2
        }}
      >
        <Grid container spacing={3} alignItems="center" style={{display:"flex",justifyContent:"space-between"}}>
          <Grid item sx={{display:"flex", alignItems: "center"}}>
            <MDAvatar src={avatarUrl} alt="profile-image" size="xl" shadow="sm" />
              <MDBox ml={2} height="100%" mt={0.5} lineHeight={1}>
                  {checkPermission(PERMISSION_DICT.QueryOwnerInfo)?
                      <MDBox>
                          <MDTypography variant="h5" fontWeight="medium">
                              {userInfo?.userName}
                          </MDTypography>
                          <MDTypography variant="button" color="text" fontWeight="regular">
                              Admin account
                          </MDTypography>
                      </MDBox>
                      :
                      <MDBox>
                          <MDTypography variant="h5" fontWeight="medium">
                              {userInfo?.userName}
                          </MDTypography>
                          <MDTypography variant="button" color="text" fontWeight="regular">
                              {userInfo?.accountType} {userInfo?.companyName}
                          </MDTypography>
                      </MDBox>
                  }
              </MDBox>
          </Grid>

          <Grid item xs={12} lg={6}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label={t("AccountPage.User Info")}
                  icon={
                    <PersonIcon fontSize="small" sx={{ mt: -0.25 }}/>
                  }
                />
                <Tab
                  label={t("AccountPage.Password")}
                  icon={
                    <PasswordIcon fontSize="small" sx={{ mt: -0.25 }}/>
                  }
                />
                  {
                      checkPermission(PERMISSION_DICT.BillingInvoiceConnect) &&
                      <Tab
                          label={t("AccountPage.Connections")}
                          icon={
                              <LinkIcon fontSize="small" sx={{ mt: -0.25 }}/>
                          }
                      />
                  }
                  {
                      !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                      <Tab
                          label={t("AccountPage.Payment")}
                          icon={
                              <CreditCardIcon fontSize="small" sx={{ mt: -0.25 }}/>
                          }
                      />
                  }
                  {
                      !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                      <Tab
                          label={t("AccountPage.Address")}
                          icon={
                              <HomeIcon fontSize="small" sx={{ mt: -0.25 }}/>
                          }
                      />
                  }
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
          {/*<CustomTabPanel value={tabValue} index={0}>*/}
          {/*    <UserInfo userInfo={userInfo} getUserInfoFetch={getUserInfoFetch}/>*/}
          {/*</CustomTabPanel>*/}
          {/*<CustomTabPanel value={tabValue} index={1}>*/}
          {/*    <PasswordSetting/>*/}
          {/*</CustomTabPanel>*/}
          {/*{*/}
          {/*    checkPermission(PERMISSION_DICT.BillingInvoiceConnect) &&*/}
          {/*    <CustomTabPanel value={tabValue} index={2}>*/}
          {/*        <ConnectionPage/>*/}
          {/*    </CustomTabPanel>*/}

          {/*}*/}
          {/*{*/}
          {/*    !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&*/}
          {/*    <CustomTabPanel value={tabValue} index={2}>*/}
          {/*        <PaymentPage/>*/}
          {/*    </CustomTabPanel>*/}

          {/*}*/}
          {/*{*/}
          {/*    !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&*/}
          {/*    <CustomTabPanel value={tabValue} index={3}>*/}
          {/*        <MultiAddress/>*/}
          {/*    </CustomTabPanel>*/}

          {/*}*/}

          <MDBox>

              <KeepAlive max={20} strategy={'PRE'} activeName={page.name} cache={page?.cache}>
                  {page && (
                      <CustomTabPanel value={tabValue} index={page.value}>
                          <div style={{ display: cacheLoading ? 'none' : 'block' }}>
                              <page.component />
                          </div>

                      </CustomTabPanel>
                  )}
              </KeepAlive>

          </MDBox>


      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default memo(Header);


